import { Achievement } from '../../types/Achievement';
import { TableColumn } from '../../utils/tableUtils';

export const achievementColumns: TableColumn<Achievement>[] = [
	{
		id: 'title',
		label: 'Title',
		sortable: true,
		accessor: (achievement) => (
			<div className="font-medium text-gray-900">
				{achievement.title}
			</div>
		)
	},
	{
		id: 'description',
		label: 'Description',
		sortable: false,
		accessor: (achievement) => (
			<div className="text-gray-600 max-w-xs truncate">
				{achievement.description}
			</div>
		)
	},
	{
		id: 'month',
		label: 'Date',
		sortable: true,
		accessor: (achievement) => (
			<div className="text-gray-900">
				{achievement.month} {achievement.year}
			</div>
		)
	},
	{
		id: 'displayOrder',
		label: 'Order',
		sortable: true,
		accessor: (achievement) => (
			<div className="text-gray-600">
				{achievement.displayOrder}
			</div>
		)
	},
	{
		id: 'active',
		label: 'Status',
		sortable: true,
		accessor: (achievement) => (
			<span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${
				achievement.active
					? 'bg-green-100 text-green-800'
					: 'bg-gray-100 text-gray-800'
			}`}>
				{achievement.active ? 'Active' : 'Inactive'}
			</span>
		)
	}
];

// Export table configuration for AdminTable component
export const achievementTableConfig = {
	entityName: 'Achievement',
	apiEndpoint: '/api/admin/achievements',
	columns: achievementColumns,
	searchFields: ['title', 'description'] as (keyof Achievement)[],
	filterOptions: {
		active: [
			{ value: 'true', label: 'Active' },
			{ value: 'false', label: 'Inactive' }
		]
	},
	bulkActions: [
		{
			id: 'activate',
			label: 'Activate Selected',
			variant: 'success' as const,
		},
		{
			id: 'deactivate',
			label: 'Deactivate Selected',
			variant: 'warning' as const,
		}
	],
	defaultSort: { field: 'displayOrder', direction: 'asc' as const },
	pageSize: 10,
	emptyMessage: 'No achievements found',
	loadingMessage: 'Loading achievements...',
	exportFileName: 'achievements',
	defaultVisibleColumns: {
		title: true,
		description: true,
		month: true,
		displayOrder: true,
		active: true
	}
};
